import { render, staticRenderFns } from "./RegistInformation.vue?vue&type=template&id=aebc2cd4&scoped=true&"
import script from "./RegistInformation.vue?vue&type=script&lang=js&"
export * from "./RegistInformation.vue?vue&type=script&lang=js&"
import style0 from "./RegistInformation.vue?vue&type=style&index=0&id=aebc2cd4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aebc2cd4",
  null
  
)

export default component.exports